'use client';

import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { pdpDocumentsOptions } from '@/api/queries/pdpDocuments';
import { MetaDataParams, PdpDocumentsDTO } from '@/types/models';
export function usePdpDocuments(): UseQueryResult<PdpDocumentsDTO> {
  const params = useParams<MetaDataParams>();
  const id = params.slug?.[0] || params.id;
  return useQuery(queryOptions(pdpDocumentsOptions(id as string)));
}